import { Pipe, PipeTransform } from '@angular/core';
import { Mediaclip } from '../interfaces/mediaclip';
import { TranslateService } from '@ngx-translate/core';

@Pipe({name: 'clipTitle'})

export class ClipTitlePipe implements PipeTransform {
	constructor(
		protected translate: TranslateService,
	) {

	}

	transform(clip: Mediaclip): string {
		if (clip.title) {
			return `<span title="${ clip.title }">${ clip.title }</span>`;
		} else if (clip.originalfilename) {
			// eslint-disable-next-line max-len
			return `<span class="filename" title="${ this.translate.instant('ORIGINAL_FILENAME') }: ${ clip.originalfilename }"> ${ clip.originalfilename }</span>`;
		} else {
			return `<span class="id" title="${ this.translate.instant('ID') }: ${ clip.id }"> ${ clip.id }</span>`;
		}
	}
}
